import { createStyles } from 'antd-style';

import {
  heightExtendingError,
  partnerAccessTopBar,
  shipmentPageInnerContentNoMargin,
} from '../styles/mixins';

export const useCopyShipmentPageStyles = createStyles(
  ({ token }, { innerContent } = {}) => ({
    copyShipmentPageWrapper: {
      '&&': {
        ...heightExtendingError(token),
        ...shipmentPageInnerContentNoMargin(token, innerContent),
      },
    },
    partnerAccessTopBar: partnerAccessTopBar(token),
  })
);
